import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "group" };
const _hoisted_2 = { class: "group__header" };
const _hoisted_3 = { class: "group__date" };
const _hoisted_4 = { class: "group__date-label" };
const _hoisted_5 = { class: "group__orders" };
const _hoisted_6 = { class: "group__supplier" };
const _hoisted_7 = { class: "group__actions" };
const _hoisted_8 = {
    key: 0,
    class: "alert alert--danger"
};
const _hoisted_9 = {
    key: 1,
    class: "alert alert--warning"
};
const _hoisted_10 = { class: "group__instructions" };
import { computed } from 'vue';
import moment from 'moment';
import VensoOrder from "@/components/VensoOrder.vue";
import ConfirmVensoOrderGroup from "@/commands/ConfirmVensoOrderGroup";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoOrderGroup',
    props: {
        group: {},
        taxRates: {}
    },
    emits: ['itemQuantityUpdate', 'addNoticeItem', 'removeNoticeItem', 'saveNoticeComment', 'confirmed'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const targetDateFormatted = computed(() => {
            return props.group && moment(props.group.deliveryDate).format('dddd, DD.MM.YYYY');
        });
        const confirmGroup = computed(() => {
            return props.group && new ConfirmVensoOrderGroup(props.group.id, props.group.accessCode);
        });
        const allNoticesLocked = computed(() => {
            return props.group && props.group.orders.every(order => {
                return order.deliveryNotice?.status === 'locked'
                    || order.deliveryReceipt != null;
            });
        });
        const allNotifiedOrReceived = computed(() => {
            return props.group && props.group.orders.every(order => order.deliveryNotice || order.deliveryReceipt);
        });
        function onDeliveryNoticeItemUpdate(update) {
            emit('itemQuantityUpdate', update);
        }
        function onDeliveryNoticeItemAdd(item) {
            emit('addNoticeItem', item);
        }
        function onDeliveryNoticeItemRemove(itemRef) {
            emit('removeNoticeItem', itemRef);
        }
        function onDeliveryNoticeSaveComment(orderId, comment) {
            emit('saveNoticeComment', orderId, comment);
        }
        const deliveryToday = computed(() => {
            return props.group.deliveryDate === new Date().toISOString().split('T')[0];
        });
        const deliveryDatePassed = computed(() => {
            return props.group.deliveryDate < new Date().toISOString().split('T')[0];
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('venso_order_group.deliveryDate')), 1),
                        _createTextVNode(" " + _toDisplayString(targetDateFormatted.value), 1)
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('venso_order_group.order_count', { count: __props.group.orders.length })), 1),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(__props.group.supplier.name), 1),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_7, [
                        (confirmGroup.value && !allNotifiedOrReceived.value)
                            ? (_openBlock(), _createBlock(CommandButton, {
                                key: 0,
                                command: confirmGroup.value,
                                onSuccess: _cache[0] || (_cache[0] = ($event) => (emit('confirmed'))),
                                disabled: allNoticesLocked.value || deliveryDatePassed.value,
                                classes: "button button--primary"
                            }, null, 8, ["command", "disabled"]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                (!allNotifiedOrReceived.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (deliveryDatePassed.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('venso_order_group.delivery_date_passed')), 1))
                            : (deliveryToday.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('venso_order_group.delivery_date_today')), 1))
                                : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('venso_order_group.supplier_instructions')), 1)
                    ], 64))
                    : _createCommentVNode("", true),
                _cache[6] || (_cache[6] = _createTextVNode()),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.group.orders, (order) => {
                    return (_openBlock(), _createBlock(VensoOrder, {
                        key: order.id,
                        order: order,
                        "tax-rates": __props.taxRates,
                        onUpdateQuantity: onDeliveryNoticeItemUpdate,
                        onAddNoticeItem: onDeliveryNoticeItemAdd,
                        onRemoveNoticeItem: onDeliveryNoticeItemRemove,
                        onSaveComment: c => onDeliveryNoticeSaveComment(order.id, c)
                    }, null, 8, ["order", "tax-rates", "onSaveComment"]));
                }), 128))
            ]));
        };
    }
});
